import { z } from "zod";
import superjson from "superjson";
import type { Selectable } from "kysely";
import type { Tenants } from "../../helpers/schema";

export const schema = z.object({
  tenantId: z.number().int().positive(),
});

export type OutputType = {
  success: true;
  activeTenantId: Selectable<Tenants>["id"];
};

export const postSelectProfile = async (
  body: z.infer<typeof schema>,
  init?: RequestInit
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);

  const result = await fetch("/_api/tenant-portal/select-profile", {
    ...init,
    method: "POST",
    body: superjson.stringify(validatedInput),
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });

  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(
      await result.text()
    );
    throw new Error(errorObject.error);
  }

  return superjson.parse<OutputType>(await result.text());
};